import { createContext } from 'react';
export const ApprovalContext = /*#__PURE__*/createContext(undefined);